<template>
  <section>
    <div class="container">
      <div class="row offers">
        <div class="col-12">
          <div
            v-for="(lead, idx) of renderParams.leads"
            :key="lead.id"
            class="offer"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="offer-title">
                  <div class="address-h1">{{ presentationName(lead) }}</div>
                </div>
                <Price
                  :lead="lead"
                  :config="config"
                  :currency="renderParams.currency"
                  :version="version"
                  :hidingConfig="renderParams.hidingFieldsConfig"
                  :currencyDict="renderParams.currencyDict"
                />
              </div>
              <CompanyLogo
                v-if="logoHost && renderParams.agent"
                :logoHost="logoHost"
                :customClass="'logo'"
              />
            </div>

            <Images
              :lead="lead"
              :config="config"
              :version="version"
              :agent="renderParams.agent"
            />

            <div
              v-if="lead.custom_fields_values && config.options.length > 0"
              class="params d-flex justify-content-between"
            >
              <div
                v-for="cf of optionalFields(lead)"
                :key="cf.field_id"
                class="parameter d-block d-sm-block"
              >
                <div class="description">
                  {{ this.localeService.getTranslatedParam(cf.field_name) }}
                </div>
                <div
                  v-html="cf.valueHtml"
                  class="digits"
                  :class="isDateField(cf) ? 'date-field' : ''"
                />
              </div>
            </div>

            <hr class="middle-hr" />
            <div class="content">
              <div
                v-html="d.description"
                v-for="d of getDescriptions(lead)"
                :key="d.id"
              />
            </div>

            <Maps
              :type="mapsType"
              :version="version"
              :isInfrastructure="config.isInfrastructure"
              :address="renderParams.map[idx]"
              :leadId="lead.id"
              :yakey="renderParams.yakey"
              :localeService="localeService"
              :latitude="latitude(lead)"
              :longitude="longitude(lead)"
            />
          </div>
        </div>

        <PersonalAgent
          :localeService="localeService"
          :renderParams="renderParams"
          :version="version"
          class="col-12"
        />

        <div class="col-12">
          <div class="d-flex justify-content-between actions">
            <PrintAction :localeService="localeService" />
            <QRcodeAction :localeService="localeService" />
          </div>
          <br />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import Price from '../common/Price.vue'
import CompanyLogo from '../common/CompanyLogo.vue'
import Images from '../common/Images/Images.vue'
import Maps from '../common/Maps.vue'
import PersonalAgent from '../common/PersonalAgent.vue'
import PrintAction from './PrintAction.vue'
import QRcodeAction from './QRcodeAction.vue'
import Locale from '../../../services/locale'
import Common from '../../../services/common'

export default {
  name: 'Print',
  props: {
    renderParams: Object,
    version: String,
    localeService: Locale,
  },
  components: {
    Price,
    CompanyLogo,
    Images,
    Maps,
    PersonalAgent,
    PrintAction,
    QRcodeAction,
  },
  computed: {
    config() {
      return this.renderParams.config
    },
    logoHost() {
      return this.renderParams.logoHost
    },
    mapsType() {
      return this.renderParams.config?.maps?.type || 'yandex'
    },
  },
  methods: {
    isDateField: Common.isDateField,
    optionalFields(lead) {
      const cfs = lead.custom_fields_values
      return this.config.options
        .map((o) => {
          const field = cfs?.find((cf) => cf.field_id === o)
          const options = this.renderParams.optionsNames
          const option = options?.find((opt) => Number(opt.id) === Number(o))
          if (o === 1) {
            return {
              field_type: 'numeric',
              field_name: 'Комиссия',
              field_id: 1,
              values: [
                {
                  value: lead.price,
                },
              ],
            }
          }
          if (!field) {
            return option?.type === 'checkbox' && Common.getDefaultField(option)
          }
          return field
        })
        .filter(Boolean)
        .map((field) =>
          Common.getFormattedField({
            field,
            dateFormat: this.renderParams.date,
            fieldsConfig: this.renderParams.hidingFieldsConfig,
            currencyDict: this.renderParams.currencyDict,
            priceFrom: this.renderParams.config.priceFrom,
            priceFieldId: this.renderParams.config.price,
            currencySymbol: this.renderParams.currency.symbol_native,
            localeService: this.localeService,
          }),
        )
    },
    getDescriptions(lead) {
      try {
        const textFields = this.config.text
        return textFields
          .map(({ id }, idx) => {
            const descriptionField = lead.custom_fields_values?.find(
              (cf) => cf.field_id === id,
            )
            if (!descriptionField) return
            const rawDescription = descriptionField?.values[0].value
            const noDescription = idx === 0 ? 'Нет описания' : ''
            const description =
              rawDescription?.replaceAll('!n', '') || noDescription
            return { id, description }
          })
          .filter(Boolean)
      } catch (e) {
        console.error(e)
        return []
      }
    },
    latitude(lead) {
      const latitudeField = lead.custom_fields_values?.find(
        (cf) => cf.field_id === this.config.latitude,
      )
      return latitudeField ? latitudeField.values[0].value : ''
    },
    longitude(lead) {
      const longitudeField = lead.custom_fields_values?.find(
        (cf) => cf.field_id === this.config.longitude,
      )
      return longitudeField ? longitudeField.values[0].value : ''
    },
    presentationName(lead) {
      const presentationNameField = lead.custom_fields_values?.find(
        (cf) => cf.field_id === this.config.presentationNameFieldId,
      )
      return presentationNameField?.values[0].value || lead.name
    },
  },
  mounted() {
    document.body.classList.add('a4')
  },
}
</script>

<style scoped>
@import '../../../assets/style.css';
.date-field {
  white-space: nowrap;
}
</style>
